const COLORS = {
  white: '#fff',
  black: '#000',
  brandBlue: '#00A9DF',
  brandBlueDark: '#202859',
  brandGreen: '#57b578',
  brandRed: '#f06651',
  brandWarn: 'rgba(248, 190, 44, 0.8)',
  bodyColor: '#313335',
  brandGreyLight: 'rgba(49, 51, 53, 0.7)',
  brandGrey: '#969696',
  greyLight: '#f8f8f8',
  steelGrey: 'rgba(134, 136, 138, 0.8)',
  footerGrey: '#caccce',
  footerText: '#86888a',
  lightestGrey: '#f9f9f9',
  greyBorder: '#d4d4d5',
  boxShadow: 'rgba(0, 0, 0, 0.2)',
  brandGrayDark: 'rgba(34, 36, 38, 0.15)',
  disabled: '#a9a9a9',
  greyOverlay: '#f2f2f2',
  newBrandBlue: '#354087',
  subheadcolor: '#a7a7a7',
  brandBlueProgess: '#46aeee',
  disabled1: '#efefef',
  disabled2: '#ebebeb',
  bordernew: '#dedede',
  borderbottom: '#f5f5f5',
  newerror: '#f92929',
  borderbottomtext: '#e0e0e0',
  tableBorderBlue: '#b3cde2',
  tableBorderGrey: '#ebebeb',
  tableTrBlue: '#d3f0fa',
  cancelImgColor: '#8bc4e8',
  formHeaderBackground: '#e7f5fb',
  inputBorder: '#e1e1e1',
  pageBgColor: '#F7F7F7',
  brandBlueBg: '#edf9fd',
  greyTextColor: '#9b9b9b',
  grey200: '#e8e8e8',
  btnTextGrey: '#919192',
  greyBgColor: '#f6f6f6',
  darkBlueColor: '#253494',
  boxShadowCard: '2px 2px 0 0 rgba(0, 0, 0, 0.05)',
  materialUiTextFieldColor: '#000000',
  brandPrimary: '#FE0095',
  brandPrimaryHover: '#BF0070',
  brandSecondary: '#48F9FE',
  red: '#FE0000',
  textLightGrey: '#747474',
  textGrey: '#333333',
  textDarkGray: '#a9a9a9',
  disabledTextColor: '#96a4b9',
  dividerBlue: '#48FAFF',
  brandPurple: '#752EFF',
  textPurple: '#746f9f',
  cardsPink: '#ac37eb',
  borderGrey: '#F0F0F0',
  lightGrey: '#F0F0F0',
  lightShadedGrey: '#FAFAFA',
  lightGreen: '#4EB014',
  green: '#236200',
  pink: '#feeff8',
  darkBlue: '#007aff',
  borderBlue: '#cfd6e4',
  textLinkBlue: '#0a79ee',
  backgroudDarkPurple: '#5220B3',
  borderLightBlue: '#36BBBF',
  lightBlue: '#30FAFF33',
  lightBlueDark: '#48faff66', //rgba(72, 250, 255, 0.4)
  lightborderBlue: '#48faff33', //rgba(72, 250, 255, 0.2)
  lightBlueBackground: '#edfeff', //rgba(72, 250, 255, 0.1)
  borderGreyLight: '#EAEAEA',
  boxShadowBlackShade: '#0000001a',
  lightBrand: '#48FAFF33',
  boxLightShadow: '#0000001a',
  aqua: '#00c1ff',
  lightestPink: '#fe00951a',
  lightPink: '#fff6fc',
  orange: '#ff8d1e66',
  solidOrange: '#FF8D1E',
  lightOrange: '#ff8d1e1a',
  blackShadow: '#0000000f',
  lightPinkBrd: `rgba(254, 0, 149, .2)`
};

export default COLORS;
